import React from 'react';
import classnames from 'classnames';
import bulletItemStyle from './BulletItem.scss';
const BulletList = ({ children , className  })=>/*#__PURE__*/ React.createElement("ul", {
        className: classnames(bulletItemStyle['list'], className)
    }, children);
BulletList.displayName = 'BulletList';
export default BulletList;
